"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFileIdFromString = exports.intFromUuid = exports.parseFileId = void 0;
const fileIdRegEx = /[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}-[a-z0-9]+-[a-z0-9]+/;
function parseFileId(fileId) {
    if (fileId.split("-").length !== 7) {
        throw new Error("Invalid file ID: " + fileId);
    }
    const extensionSeparatorIndex = fileId.lastIndexOf("-");
    const uuidAndType = fileId.substring(0, extensionSeparatorIndex);
    const typeSeparatorIndex = uuidAndType.lastIndexOf("-");
    const id = uuidAndType.substring(0, typeSeparatorIndex);
    const key = intFromUuid(id);
    const encodedFileType = uuidAndType.substring(typeSeparatorIndex + 1);
    const decodedFileType = Buffer.from(encodedFileType, "hex").map((val) => val - key)[0];
    const encodedFileExtension = fileId.substring(extensionSeparatorIndex + 1);
    const decodedFileExtension = Buffer.from(Buffer.from(encodedFileExtension, "hex").map((val) => val - key)).toString();
    return {
        id,
        fileType: decodedFileType,
        fileExtension: decodedFileExtension.toLowerCase(),
    };
}
exports.parseFileId = parseFileId;
function intFromUuid(id) {
    return Buffer.from(id)
        .slice(-12)
        .reduce((acc, val) => acc + val);
}
exports.intFromUuid = intFromUuid;
function extractFileIdFromString(url) {
    const match = fileIdRegEx.exec(url);
    if (!match) {
        return;
    }
    return match[0];
}
exports.extractFileIdFromString = extractFileIdFromString;
//# sourceMappingURL=fileId.js.map